var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',_vm._b({attrs:{"type":"password","maxlength":"6","auto-complete":"new-password","placeholder":_vm.placeholder || 'account password',"value":_vm.value},on:{"input":_vm.handleInput,"change":function($event){return _vm.$emit('change', $event)}}},'el-input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }